import React from 'react'

const NotFound = ({ data }) => {
  return (
    <React.Fragment>
      <div class="content"><h2>Упс, ничего не найдено!</h2>
      <img src="../img/family.jpg" alt="notfound"/></div>
    </React.Fragment>
  )
}

export default NotFound

